var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriforce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 152.027344 256.945313 L 208.148438 159.746094 C 209.164063 157.984375 207.894531 155.785156 205.859375 155.785156 L 93.625 155.785156 C 91.59375 155.785156 90.324219 157.984375 91.339844 159.746094 L 147.457031 256.945313 C 148.472656 258.707031 151.011719 258.707031 152.027344 256.945313 L 208.148438 159.746094 C 209.164063 157.984375 207.894531 155.785156 205.859375 155.785156 L 93.625 155.785156 C 91.59375 155.785156 90.324219 157.984375 91.339844 159.746094 L 147.457031 256.945313 C 148.472656 258.707031 151.011719 258.707031 152.027344 256.945313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 148.21875 74.226563 L 110.757813 139.105469 C 110.078125 140.28125 110.929688 141.75 112.285156 141.75 L 187.203125 141.75 C 188.558594 141.75 189.40625 140.28125 188.726563 139.105469 L 151.269531 74.226563 C 150.589844 73.054688 148.894531 73.054688 148.21875 74.226563 L 110.757813 139.105469 C 110.078125 140.28125 110.929688 141.75 112.285156 141.75 L 187.203125 141.75 C 188.558594 141.75 189.40625 140.28125 188.726563 139.105469 L 151.269531 74.226563 C 150.589844 73.054688 148.894531 73.054688 148.21875 74.226563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 215.214844 147.894531 L 271.332031 50.691406 C 272.347656 48.933594 271.078125 46.734375 269.046875 46.734375 L 156.808594 46.734375 C 154.777344 46.734375 153.507813 48.933594 154.523438 50.691406 L 210.644531 147.894531 C 211.65625 149.652344 214.195313 149.652344 215.214844 147.894531 L 271.332031 50.691406 C 272.347656 48.933594 271.078125 46.734375 269.046875 46.734375 L 156.808594 46.734375 C 154.777344 46.734375 153.507813 48.933594 154.523438 50.691406 L 210.644531 147.894531 C 211.65625 149.652344 214.195313 149.652344 215.214844 147.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.799561%,0.799561%,0.799561%)",
      fillOpacity: 1
    },
    d: "M 89.359375 147.894531 L 145.476563 50.691406 C 146.492188 48.933594 145.222656 46.734375 143.191406 46.734375 L 30.953125 46.734375 C 28.921875 46.734375 27.652344 48.933594 28.667969 50.691406 L 84.785156 147.894531 C 85.800781 149.652344 88.339844 149.652344 89.359375 147.894531 L 145.476563 50.691406 C 146.492188 48.933594 145.222656 46.734375 143.191406 46.734375 L 30.953125 46.734375 C 28.921875 46.734375 27.652344 48.933594 28.667969 50.691406 L 84.785156 147.894531 C 85.800781 149.652344 88.339844 149.652344 89.359375 147.894531 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriforce);
export default __webpack_public_path__ + "static/media/Triforce.d80d28994bc81ab1ca158e12339e74d9.svg";
export { ForwardRef as ReactComponent };